import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 py-24 text-center">
      <span className="pointer-events-none absolute select-none font-heading text-[8rem] font-black leading-none text-background-200 md:text-[14rem]">
        404
      </span>
      <div className="relative z-10">
        <i className="ri-ghost-2-line text-5xl text-primary-500"></i>
        <h1 className="mt-6 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这个页面暂时没有内容
        </h1>
        <p className="mt-3 text-sm text-foreground-500">路径：{location.pathname}</p>
        <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
          页面可能已被移除，或者地址输入有误。回到首页，看看今天有什么新瓜。
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/hot"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-fire-line"></i>
            查看热榜
          </Link>
        </div>
      </div>
    </div>
  );
}